import type { ReactNode } from 'react';

type Side = 'top' | 'bottom' | 'left' | 'right';
type Tone = 'default' | 'accent' | 'danger' | 'ghost';

/**
 * Ярлык — «символ многообразия различных продуктов внутри масштабной
 * системы GTO GROUP и её структурного подхода в работе» (брендбук, стр. 29).
 *
 * Плоская сторона стыкуется с краем пространства, противоположные углы
 * скруглены (стр. 32). `side` указывает, к какому краю ярлык примыкает.
 */
export function Yarlyk({
  children,
  side = 'bottom',
  tone = 'default',
  className = '',
  ...rest
}: {
  children: ReactNode;
  side?: Side;
  tone?: Tone;
  className?: string;
} & React.HTMLAttributes<HTMLSpanElement>) {
  const classes = [
    'yarlyk',
    `yarlyk--${side}`,
    tone !== 'default' ? `yarlyk--${tone}` : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes} {...rest}>
      {children}
    </span>
  );
}
